// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"a10a3f92e9--tooltip--V83hj","arrow_tooltip":"a10a3f92e9--arrow_tooltip--Iqx7l","arrow":"a10a3f92e9--arrow--qKq6Q"};